import { baseCrumbClasses } from './Breadcrumbs';

interface ButtonCrumbProps {
  buttonText: string
}

export const ButtonCrumb = (props: ButtonCrumbProps) => {
  const {
    buttonText
  } = props;

  return (
    <button className={`${baseCrumbClasses} text-sm compact:text-xs md:text-base p-2 compact:py-1 compact:px-4 lg:px-6`}>{buttonText}</button>
  )
}